import { anim, stagger } from '../../../motion'
import { Shape } from '../../../primitives'
import { Line, Words } from '../../../v2/kit'
import { useCopy, useLang } from '../../i18n'
import { toTop } from '../../kit'

// Die Formen blühen auf wie in Version 2, danach Argumente, nächste Schritte und Kontakt
const KINDS = ['tri', 'sq', 'dot']
const TONES = ['#FFFFFF', 'yellow', 'green', 'pink']
const GOLDEN = 2.39996
const BORDERS = ['var(--pink)', 'var(--yellow)', 'var(--green)']

const BLOOM = Array.from({ length: 36 }, (_, i) => {
  const angle = i * GOLDEN
  const dist = 22 + ((i * 37) % 30)
  return {
    kind: KINDS[i % 3],
    color: TONES[i % 4],
    x: Math.cos(angle) * dist * 1.25,
    y: Math.sin(angle) * dist * 0.85,
    r: ((i * 47) % 120) - 60,
    size: 18 + ((i * 11) % 34),
    at: [0.04 + (i % 7) * 0.012, 0.3 + (i % 7) * 0.012]
  }
})

export default function DemoClose() {
  const c = useCopy('abschluss')
  const lang = useLang()
  const candidateHref = `${window.location.pathname}?v=bewerbende${lang === 'en' ? '&lang=en' : ''}`

  return (
    <div className='cin-full cin-finale'>
      {BLOOM.map((b, i) => (
        <div
          key={i}
          className='cin-bloom'
          style={{
            left: `calc(50% + ${b.x}cqw)`,
            top: `calc(50% + ${b.y}cqh)`
          }}
        >
          <div
            style={anim({
              at: b.at,
              out: [0.5, 0.6],
              x: -b.x * 9,
              y: -b.y * 6,
              s: 0.1,
              r: b.r * 3,
              oy: 0
            })}
          >
            <Shape kind={b.kind} color={b.color} size={b.size} rotate={b.r} />
          </div>
        </div>
      ))}

      <div
        className='cin-finale__hello'
        style={anim({ at: [-1, 0], out: [0.5, 0.58], oy: -60 })}
      >
        <h2 className='cin-display cin-display--white dm-close-title'>
          <Words text={c.title} at={[0.12, 0.34]} dim={0.25} />
        </h2>
        <Line at={[0.32, 0.4]} y={20} className='cin-finale__sub'>
          {c.sub}
        </Line>
      </div>

      <div className='dm-close'>
        <div className='dm-close__col' style={anim({ at: [0.6, 0.7], y: 60 })}>
          <div className='dm-close__eyebrow'>{c.why}</div>
          {c.points.map((p, i) => (
            <div
              key={p.title}
              className='dm-close__point'
              style={{ borderColor: BORDERS[i] }}
            >
              <div className='dm-close__point-title'>{p.title}</div>
              <div className='dm-close__point-text'>{p.text}</div>
            </div>
          ))}
        </div>
        <div className='dm-close__col'>
          <div
            className='dm-close__eyebrow'
            style={anim({ at: [0.64, 0.72], y: 30 })}
          >
            {c.next}
          </div>
          <ol className='dm-next'>
            {c.steps.map((s, i) => (
              <li
                key={s.title}
                style={anim({ at: stagger(0.66, 0.03, 0.08, i), x: 40, y: 0 })}
              >
                <span className='dm-next__num'>{i + 1}</span>
                <div>
                  <div className='dm-next__title'>{s.title}</div>
                  <div className='dm-next__text'>{s.text}</div>
                </div>
              </li>
            ))}
          </ol>
          <div
            className='cin-finale__actions'
            style={anim({ at: [0.8, 0.88], y: 30 })}
          >
            <a
              href={c.ctaHref}
              target='_blank'
              rel='noreferrer'
              className='cin-cta'
            >
              {c.cta}
            </a>
            <a href={candidateHref} className='cin-cta cin-cta--ghost'>
              {c.candidate}
            </a>
            <button
              type='button'
              onClick={toTop}
              className='cin-cta cin-cta--ghost'
            >
              {c.again}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}
